/**
 * Do not edit directly
 * Generated on Mon, 18 Mar 2024 03:13:46 GMT
 */

export const assetFontSephorasansName = 'Sephora Sans'
export const assetFontSephoraserifName = 'Sephora Serif'
export const colorBackgroundBase = '#FFFFFF'
export const colorBackgroundInfo = '#EBF8FF'
export const colorBackgroundError = '#FDE8E9'
export const colorBackgroundWarning = '#FDF8EC'
export const colorBackgroundSuccess = '#E5F2EE'
export const colorBackgroundButtonPrimaryBase = '#DD0031'
export const colorBackgroundButtonPrimaryDisabled = '#E74C6F'
export const colorBackgroundButtonPrimaryActive = '#FCE5EA'
export const colorBaseRed10 = '#FCE5EA'
export const colorBaseRed70 = '#E74C6F'
export const colorBaseRed100 = '#DD0031'
export const colorBaseRedN100 = '#E81728'
export const colorBaseRedN10 = '#FDE8E9'
export const colorBasePink10 = '#FCE5F6'
export const colorBasePink70 = '#E74CBD'
export const colorBasePink100 = '#DD00A0'
export const colorBaseGold10 = '#F5F0E5'
export const colorBaseGold70 = '#B8984C'
export const colorBaseGold100 = '#996C00'
export const colorBasePurple10 = '#F4F2FD'
export const colorBasePurple70 = '#B5A5F4'
export const colorBasePurple100 = '#957FEF'
export const colorBaseBlue10 = '#E5F1FC'
export const colorBaseBlue70 = '#4C9EE9'
export const colorBaseBlue100 = '#0074E0'
export const colorBaseBlueN100 = '#1E78C2'
export const colorBaseBlueN10 = '#EBF8FF'
export const colorBaseYellowN100 = '#ECB63D'
export const colorBaseYellowN10 = '#FDF8EC'
export const colorBaseGreenN100 = '#007C5A'
export const colorBaseGreenN10 = '#E5F2EE'
export const colorBaseGrey10 = '#E5E5E5'
export const colorBaseGrey30 = '#B3B3B3'
export const colorBaseGrey50 = '#808080'
export const colorBaseGrey70 = '#4C4C4C'
export const colorBaseGrey05 = '#F2F2F2'
export const colorBaseBlack = '#000000'
export const colorBaseWhite = '#FFFFFF'
export const colorBorderDividerPrimary = '#B3B3B3'
export const colorBorderDividerSecondary = '#E5E5E5'
export const colorBrandPrimaryLighter = '#FCE5EA'
export const colorBrandPrimaryLight = '#E74C6F'
export const colorBrandPrimaryBase = '#DD0031'
export const colorBrandSecondaryVirtualBundleLighter = '#FCE5F6'
export const colorBrandSecondaryVirtualBundleLight = '#E74CBD'
export const colorBrandSecondaryVirtualBundleBase = '#DD00A0'
export const colorBrandSecondaryGoldTierRewardsLighter = '#F5F0E5'
export const colorBrandSecondaryGoldTierRewardsLight = '#B8984C'
export const colorBrandSecondaryGoldTierRewardsBase = '#996C00'
export const colorBrandSecondaryDigitalWalletLighter = '#F4F2FD'
export const colorBrandSecondaryDigitalWalletLight = '#B5A5F4'
export const colorBrandSecondaryDigitalWalletBase = '#957FEF'
export const colorBrandSecondaryBaLighter = '#E5F1FC'
export const colorBrandSecondaryBaLight = '#4C9EE9'
export const colorBrandSecondaryBaBase = '#0074E0'
export const colorFontPrimary = '#000000'
export const colorFontSecondary = '#808080'
export const colorFontDisabled = '#B3B3B3'
export const colorFontWhite = '#FFFFFF'
export const colorFontInfo = '#1E78C2'
export const colorFontError = '#E81728'
export const colorFontWarning = '#ECB63D'
export const colorFontSuccess = '#007C5A'
export const colorFontButtonPrimary = '#FFFFFF'
export const colorFontButtonSecondary = '#FFFFFF'
export const colorFontButtonTertiary = '#000000'
export const colorRgbBackgroundBase = '255,255,255'
export const colorRgbBackgroundInfo = '235,248,255'
export const colorRgbBackgroundError = '253,232,233'
export const colorRgbBackgroundWarning = '253,248,236'
export const colorRgbBackgroundSuccess = '229,242,238'
export const colorRgbBackgroundButtonPrimaryBase = '221,0,49'
export const colorRgbBackgroundButtonPrimaryDisabled = '231,76,111'
export const colorRgbBackgroundButtonPrimaryActive = '252,229,234'
export const colorRgbBaseRed10 = '252,229,234'
export const colorRgbBaseRed70 = '231,76,111'
export const colorRgbBaseRed100 = '221,0,49'
export const colorRgbBaseRedN100 = '232,23,40'
export const colorRgbBaseRedN10 = '253,232,233'
export const colorRgbBasePink10 = '252,229,246'
export const colorRgbBasePink70 = '231,76,189'
export const colorRgbBasePink100 = '221,0,160'
export const colorRgbBaseGold10 = '245,240,229'
export const colorRgbBaseGold70 = '184,152,76'
export const colorRgbBaseGold100 = '153,108,0'
export const colorRgbBasePurple10 = '244,242,253'
export const colorRgbBasePurple70 = '181,165,244'
export const colorRgbBasePurple100 = '149,127,239'
export const colorRgbBaseBlue10 = '229,241,252'
export const colorRgbBaseBlue70 = '76,158,233'
export const colorRgbBaseBlue100 = '0,116,224'
export const colorRgbBaseBlueN100 = '30,120,194'
export const colorRgbBaseBlueN10 = '235,248,255'
export const colorRgbBaseYellowN100 = '236,182,61'
export const colorRgbBaseYellowN10 = '253,248,236'
export const colorRgbBaseGreenN100 = '0,124,90'
export const colorRgbBaseGreenN10 = '229,242,238'
export const colorRgbBaseGrey10 = '229,229,229'
export const colorRgbBaseGrey30 = '179,179,179'
export const colorRgbBaseGrey50 = '128,128,128'
export const colorRgbBaseGrey70 = '76,76,76'
export const colorRgbBaseGrey05 = '242,242,242'
export const colorRgbBaseBlack = '0,0,0'
export const colorRgbBaseWhite = '255,255,255'
export const colorRgbBorderDividerPrimary = '179,179,179'
export const colorRgbBorderDividerSecondary = '229,229,229'
export const colorRgbBrandPrimaryLighter = '252,229,234'
export const colorRgbBrandPrimaryLight = '231,76,111'
export const colorRgbBrandPrimaryBase = '221,0,49'
export const colorRgbBrandSecondaryVirtualBundleLighter = '252,229,246'
export const colorRgbBrandSecondaryVirtualBundleLight = '231,76,189'
export const colorRgbBrandSecondaryVirtualBundleBase = '221,0,160'
export const colorRgbBrandSecondaryGoldTierRewardsLighter = '245,240,229'
export const colorRgbBrandSecondaryGoldTierRewardsLight = '184,152,76'
export const colorRgbBrandSecondaryGoldTierRewardsBase = '153,108,0'
export const colorRgbBrandSecondaryDigitalWalletLighter = '244,242,253'
export const colorRgbBrandSecondaryDigitalWalletLight = '181,165,244'
export const colorRgbBrandSecondaryDigitalWalletBase = '149,127,239'
export const colorRgbBrandSecondaryBaLighter = '229,241,252'
export const colorRgbBrandSecondaryBaLight = '76,158,233'
export const colorRgbBrandSecondaryBaBase = '0,116,224'
export const colorRgbFontPrimary = '0,0,0'
export const colorRgbFontSecondary = '128,128,128'
export const colorRgbFontDisabled = '179,179,179'
export const colorRgbFontWhite = '255,255,255'
export const colorRgbFontInfo = '30,120,194'
export const colorRgbFontError = '232,23,40'
export const colorRgbFontWarning = '236,182,61'
export const colorRgbFontSuccess = '0,124,90'
export const colorRgbFontButtonPrimary = '255,255,255'
export const colorRgbFontButtonSecondary = '255,255,255'
export const colorRgbFontButtonTertiary = '0,0,0'
export const sizeBreakpointsMobileMaxWidth = '767px'
export const sizeBreakpointsTabletMinWidth = '768px'
export const sizeBreakpointsTabletMaxWidth = '1023px'
export const sizeBreakpointsDesktopMinWidth = '1024px'
export const sizeBreakpointsDesktopMaxWidth = '1279px'
export const sizeBreakpointsWidescreenMinWidth = '1280px'
export const sizeBreakpointsWidescreenMaxWidth = '1439px'
export const sizeBreakpointsFullhdMinWidth = '1440px'
export const sizeRadiusNo = '0px'
export const sizeRadiusLow = '4px'
export const sizeRadiusMedium = '8px'
export const sizeRadiusHigh = '16px'
export const sizeTypescaleDisplayXlFont = 'Sephora Sans'
export const sizeTypescaleDisplayXlSize = '40px'
export const sizeTypescaleDisplayXlLineHeight = '1.5'
export const sizeTypescaleDisplayXlSpacing = '0'
export const sizeTypescaleDisplayXlWeight = '400'
export const sizeTypescaleDisplayLFont = 'Sephora Sans'
export const sizeTypescaleDisplayLSize = '32px'
export const sizeTypescaleDisplayLLineHeight = '1.5'
export const sizeTypescaleDisplayLSpacing = '0'
export const sizeTypescaleDisplayLWeight = '400'
export const sizeTypescaleDisplayMFont = 'Sephora Sans'
export const sizeTypescaleDisplayMSize = '24px'
export const sizeTypescaleDisplayMLineHeight = '1.5'
export const sizeTypescaleDisplayMSpacing = '0'
export const sizeTypescaleDisplayMWeight = '400'
export const sizeTypescaleHeadlineXlFont = 'Sephora Sans'
export const sizeTypescaleHeadlineXlSize = '20px'
export const sizeTypescaleHeadlineXlLineHeight = '1.5'
export const sizeTypescaleHeadlineXlSpacing = '0'
export const sizeTypescaleHeadlineXlWeight = '700'
export const sizeTypescaleHeadlineLFont = 'Sephora Sans'
export const sizeTypescaleHeadlineLSize = '16px'
export const sizeTypescaleHeadlineLLineHeight = '1.5'
export const sizeTypescaleHeadlineLSpacing = '0'
export const sizeTypescaleHeadlineLWeight = '700'
export const sizeTypescaleHeadlineMFont = 'Sephora Sans'
export const sizeTypescaleHeadlineMSize = '14px'
export const sizeTypescaleHeadlineMLineHeight = '1.5'
export const sizeTypescaleHeadlineMSpacing = '0'
export const sizeTypescaleHeadlineMWeight = '700'
export const sizeTypescaleHeadlineSFont = 'Sephora Sans'
export const sizeTypescaleHeadlineSSize = '12px'
export const sizeTypescaleHeadlineSLineHeight = '1.5'
export const sizeTypescaleHeadlineSSpacing = '0'
export const sizeTypescaleHeadlineSWeight = '700'
export const sizeTypescaleBodyLFont = 'Sephora Sans'
export const sizeTypescaleBodyLSize = '16px'
export const sizeTypescaleBodyLLineHeight = '1.5'
export const sizeTypescaleBodyLSpacing = '0'
export const sizeTypescaleBodyLWeight = '400'
export const sizeTypescaleBodyMFont = 'Sephora Sans'
export const sizeTypescaleBodyMSize = '14px'
export const sizeTypescaleBodyMLineHeight = '1.5'
export const sizeTypescaleBodyMSpacing = '0'
export const sizeTypescaleBodyMWeight = '400'
export const sizeTypescaleBodySFont = 'Sephora Sans'
export const sizeTypescaleBodySSize = '12px'
export const sizeTypescaleBodySLineHeight = '1.5'
export const sizeTypescaleBodySSpacing = '0'
export const sizeTypescaleBodySWeight = '400'
export const sizeTypescaleBodyXsFont = 'Sephora Sans'
export const sizeTypescaleBodyXsSize = '10px'
export const sizeTypescaleBodyXsLineHeight = '1.5'
export const sizeTypescaleBodyXsSpacing = '0'
export const sizeTypescaleBodyXsWeight = '400'
export const sizeTypescaleCaptionSFont = 'Sephora Sans'
export const sizeTypescaleCaptionSSize = '12px'
export const sizeTypescaleCaptionSLineHeight = '1.5'
export const sizeTypescaleCaptionSSpacing = '1.5px'
export const sizeTypescaleCaptionSWeight = '600'
export const sizeTypescaleCaptionMFont = 'Sephora Sans'
export const sizeTypescaleCaptionMSize = '10px'
export const sizeTypescaleCaptionMLineHeight = '1.5'
export const sizeTypescaleCaptionMSpacing = '1.5px'
export const sizeTypescaleCaptionMWeight = '600'
export const sizeTypographyWeightBold = '700'
export const sizeTypographyWeightMedium = '600'
export const sizeTypographyWeightBook = '400'
export const sizeTypographyWeightLight = '300'
export const sizeTypographySize10 = '10px'
export const sizeTypographySize12 = '12px'
export const sizeTypographySize14 = '14px'
export const sizeTypographySize16 = '16px'
export const sizeTypographySize20 = '20px'
export const sizeTypographySize24 = '24px'
export const sizeTypographySize32 = '32px'
export const sizeTypographySize40 = '40px'
export const sizeTypographyLineHeight125 = '125'
export const sizeTypographyLineHeight15 = '1.5'
export const sizeTypographySpacing0 = '0'
export const sizeTypographySpacing15 = '1.5px'
export const sizeZIndexMenuContainer = '1015'
export const sizeZIndexSticky = '1020'
export const sizeZIndexModalBackdrop = '1040'
export const sizeZIndexModal = '1050'
export const sizeZIndexPopover = '1060'
export const sizeZIndexTooltip = '1070'
export const sizeZIndexToast = '1080'
